import { StyleSheet } from 'react-native'
import spacing from '../../styles/spacing'
export const styles = StyleSheet.create({
  container: { flex: 1 },
  contentContainer: { padding: spacing.m2, flex: 1 },
  tableWrapper: { flex: 1 },
  parametersWrapper: { paddingBottom: spacing.m4 }
})
